import React, { Component, Fragment } from 'react';
import { Redirect, withRouter } from 'react-router-dom';
import { ValidatorForm } from 'react-form-validator-core';
import { ValidatorForm as NewValidatorForm } from 'react-form-validator-core';

import _ from 'lodash';

import Footer from './Footer';
import { m } from '../../utils';
import './report.css';

import ScrollLock from 'react-scrolllock';
import EncourageScroll from '../EncourageScroll';
import DesktopFooter from './DesktopFooter';
import Header from './ReportHeader';
import NewMileage from './NewMileage';
import NewIncidentType from './NewIncidentType';
import IssueType from './IssueType';
import NewDamageLocation from './NewDamageLocation';
import SpecifyLocation from './SpecifyLocation';
import NewImageUploader from './NewImageUploader';
import SendModal from './SendModal';
import BookingPromptModal from './BookingPromptModal';
import SideBarContent from '../SideBar/SideBarContent';
import TextBox from '../../artzu-ui/src/TextBox';
import Modal from '../../artzu-ui/src/Modal';
import Button from '../../artzu-ui/src/Button';
import Loading from '../shared/Loading';
import OfflineModal from './OfflineModal';

class Report extends Component {
  constructor(props) {
    super(props);
    this.state = {
      booking_id: '',
      bookingTitle: '',
      reported_mileage: '',
      type_of_incident: '',
      location_of_damage: '',
      notes: '',
      car_id: 0,
      images: [0, 0, 0, 0, 0],
      open: false,
      disabled: false,
      modalMessage: '',
      modal: false,
      imageError: '',
      selectBookingPrompt: false,
      vehicle_issue: '',
      offline: false,
      typeError: '',
      odometerError: '',
      detailsError: '',
      issueError: '',
      locationError: '',
      showAccidentModal: false
    };
  }

  componentDidMount() {
    const { state } = this.props.location;

    if (state && state.fromBooking) {
      this.setState({
        booking_id: state.bookingId,
        bookingTitle: state.bookingTitle
      });

      const carid = state.booking.car.id;
      this.setState({ car_id: carid });
    } else {
      this.setState({ selectBookingPrompt: true });
    }

    ValidatorForm.addValidationRule('imageUpload', incidentType => {
      let anyImages = false;
      this.state.images.forEach(image => {
        if (image) {
          anyImages = true;
        }
      });
      if (incidentType !== 'late_drivers' && !anyImages) {
        return false;
      }
      return true;
    });
  }

  componentWillUpdate(nextProps, nextState) {
    nextState.images.forEach((image, index) => {
      if (image) {
        this.previewFile(index);
      }
    });
  }

  previewFile = index => {
    const preview = document.getElementById(`previewImg${index}`);
    const file = document.getElementById(`img${index}`)
      ? document.getElementById(`img${index}`).files[0]
      : null;
    const reader = new FileReader();

    reader.addEventListener('load', () => {
      preview.src = reader.result;
    });

    if (file) {
      reader.readAsDataURL(file);
    }
  };

  saveFileToState = (file, index) => {
    const currentStateImages = this.state.images;
    currentStateImages[index] = file;
    this.setState({ images: currentStateImages });
  };

  removeImageFromState = index => {
    const currentStateImages = this.state.images;
    // currentStateImages.splice(index, 1);
    currentStateImages[index] = 0;
    this.setState({ images: currentStateImages });

    const preview = document.getElementById(`previewImg${index}`);
    preview.src = '';
  };

  submitReport = () => {
    if (!navigator.onLine) {
      this.setState({ offline: true });
    } else {
      this.setState({ offline: false, disabled: true });

      const body = {
        booking_id: '',
        reported_mileage: '',
        type_of_incident: '',
        location_of_damage: '',
        notes: '',
        car_id: null
      };

      const formData = new FormData();

      Object.keys(body).forEach(key => {
        if (key === 'location_of_damage') {
          formData.append(
            key,
            `${this.state.vehicle_issue}${
              this.state.location_of_damage
                ? ' (' + this.state.location_of_damage + ')'
                : ''
            }`
          );
        } else {
          formData.append(key, this.state[key]);
        }
      });

      const images = this.state.images.filter(image => image);

      images.forEach((image, i) => {
        formData.append(`photo_${i + 1}`, image);
      });

      const config = {
        method: 'POST',
        headers: {
          'X-User-Email': JSON.parse(localStorage.state).auth.email,
          'X-User-Token': JSON.parse(localStorage.state).auth.token
        },
        body: formData
      };

      fetch(`${process.env.REACT_APP_API_URL}/api/v1/report`, config)
        .then(data => data.json())
        .then(response => {
          console.log(response);
          this.openModal(response.message != 'incident reported');
        })
        .catch(() => {
          console.log('error submitting incident report!');
        });
    }
  };

  openModal = error => {
    const modalMessage = error
      ? 'There was an error submitting your report. Please try again later. '
      : 'Your incident has been reported and will be reviewed by our team. ';
    this.setState({ open: true, disabled: false, modalMessage });
  };

  validateImageCount = () => {
    const images = [...this.state.images];
    const { type_of_incident } = this.state;
    if (type_of_incident === 'late_drivers') {
      return false;
    }
    if (_.pull(images, 0).length > 0) {
      return false;
    }
    return true;
  };

  closeModal = type => {
    this.setState({
      [type]: false
    });
  };

  changeState = (field, value) => {
    this.setState({ [field]: value });
  };
  handleChange = ({ target }) => {
    const { name } = target;
    this.setState({ [name]: target.value });
  };

  handleFormSubmit = () => {
    this.setState({
      imageError: '',
      typeError: '',
      issueError: '',
      locationError: '',
      odometerError: '',
      detailsError: ''
    });
    const {
      type_of_incident,
      reported_mileage,
      notes,
      vehicle_issue,
      location_of_damage
    } = this.state;
    if (!type_of_incident) {
      this.setState({ typeError: 'You must select an incident type.' });
    } else if (type_of_incident === 'vehicle_issue' && !vehicle_issue) {
      this.setState({ issueError: 'Please select an issue type.' });
    } else if (
      type_of_incident === 'vehicle_issue' &&
      [
        'body_damage',
        'headlights',
        'doors',
        'tires',
        'windshield'
      ].includes(vehicle_issue) &&
      !location_of_damage
    ) {
      this.setState({
        locationError: 'You must specify the location of the issue.'
      });
    } else if (!reported_mileage) {
      this.setState({
        odometerError: 'You must enter the odometer reading.'
      });
    } else if (type_of_incident !== 'gas_shortages' && !notes) {
      this.setState({
        detailsError: 'Please provide additional information.'
      });
    } else if (this.validateImageCount()) {
      this.setState({ imageError: 'You must upload at least one image.' });
    } else {
      this.setState({
        imageError: '',
        typeError: '',
        odometerError: '',
        detailsError: ''
      });

      this.submitReport();
    }
  };

  report = () => {
    const { history, bookings = [], status, operatingCity } = this.props;
    const {
      reported_mileage,
      type_of_incident,
      vehicle_issue,
      location_of_damage,
      booking_id,
      imageError,
      bookingTitle,
      car_id,
      disabled,
      typeError,
      odometerError,
      detailsError,
      issueError,
      locationError,
      showAccidentModal
    } = this.state;
    const pastBookings = bookings.filter(
      booking =>
        m().isAfter(m(booking.startTime)) &&
        m().isBefore(
          m(booking.endTime)
            .clone()
            .add(2, 'hours')
        )
    );
    return (
      <Fragment>
        {disabled ? (
          <Loading size="3x" />
        ) : (
          <Fragment>
            <div className="report container">
              <div className="payments__statements--border payments__statements--border--left" />
              <Header
                persistentTitle
                title="Incident Report"
                back
                onClick={() => {
                  history.goBack();
                }}
              />
              {window.innerWidth < 768 ? (
                <Footer
                  onClick={() => {
                    this.handleFormSubmit();
                  }}
                />
              ) : null}
              <ScrollLock>
                <EncourageScroll className="report__scroll">
                  {/* <div className="report__scroll"> */}
                  <div className="report__container">
                    <Modal open={showAccidentModal}>
                      <div className="accident-modal">
                        <p>
                          If you are in an emergency situation, contact
                          emergency services and our hotline
                          1-833-692-8898. Any accidents involving a third
                          party (meaning another driver, cyclist,
                          pedestrian etc) must be reported to the police.
                          If police are not on site of the accident, you
                          must visit a collision centre within 24 hours of
                          accident (
                          <a
                            href="https://www.torontopolice.on.ca/traffic/crc.php"
                            target="_blank">
                            click this link for details
                          </a>
                          ). If you need a tow, we will assist you ASAP.
                        </p>
                        <Button
                          label="Close"
                          onClick={() =>
                            this.setState({ showAccidentModal: false })
                          }
                        />
                      </div>
                    </Modal>
                    <div className="report__sidebar">
                      <SideBarContent status={status} signedIn={status} />
                    </div>
                    <div className="flex-col report__content">
                      <div className="report__container--form">
                        <NewValidatorForm
                          className=""
                          instantValidate
                          onSubmit={() => this.handleFormSubmit()}>
                          <div className="report__booking--container">
                            <div className="report__booking--title">
                              Selected Booking
                            </div>
                            <div className="report__booking--text">
                              {booking_id
                                ? bookingTitle
                                : 'No Booking Selected'}
                            </div>
                          </div>
                          <div className="NewIncidentType">
                            <NewIncidentType
                              title="Type of Incident"
                              validators={['required']}
                              errorMessages={['This field is required']}
                              error={typeError}
                              name="type_of_incident"
                              value={type_of_incident}
                              onChange={(value, heading) =>
                                this.setState({
                                  type_of_incident: value,
                                  showAccidentModal:
                                    value === 'accident' ? true : false
                                })
                              }
                            />
                          </div>
                          {type_of_incident === 'vehicle_issue' ? (
                            <div className="IssueType">
                              <IssueType
                                error={issueError}
                                title="Vehicle Issue"
                                validators={['required']}
                                errorMessages={['This field is required']}
                                name="vehicle_issue"
                                value={vehicle_issue}
                                operatingCity={operatingCity}
                                onChange={(value, heading) =>
                                  this.setState({
                                    vehicle_issue: value
                                  })
                                }
                              />
                            </div>
                          ) : null}
                          {type_of_incident === 'vehicle_issue' &&
                          [
                            'body_damage',
                            'headlights',
                            'doors',
                            'tires',
                            'windshield'
                          ].includes(vehicle_issue) ? (
                            <div className="SpecifyLocation">
                              <SpecifyLocation
                                error={locationError}
                                title="Location of Damage"
                                validators={['required']}
                                errorMessages={['This field is required']}
                                name="location_of_damage"
                                value={location_of_damage}
                                onChange={(value, heading) =>
                                  this.setState({
                                    location_of_damage: value
                                  })
                                }
                              />
                            </div>
                          ) : null}
                          {/* {type_of_incident === 'vehicle_damage' || type_of_incident === 'accident' ? (
                            <div className="NewDamageLocation">
                              <NewDamageLocation
                                title="Damaged Area"
                                validators={['required']}
                                errorMessages={['This field is required']}
                                name="location_of_damage"
                                value={location_of_damage}
                                onChange={(value, heading) =>
                                  this.setState({
                                    location_of_damage: value,
                                  })
                                }
                              />
                            </div>
                          ) : null} */}
                          <div className="NewMileage">
                            <NewMileage
                              floatingLabelText="Odometer"
                              name="reported_mileage"
                              value={reported_mileage}
                              validators={[
                                'required',
                                'matchRegexp:^[0-9]*$',
                                'minNumber:1'
                              ]}
                              errorMessages={[
                                'This field is required',
                                'Must only include numbers',
                                'Must be a positive number'
                              ]}
                              selectedBooking={
                                pastBookings.filter(
                                  booking =>
                                    booking.id === this.state.booking_id
                                )[0]
                              }
                              // reported_mileage={this.state.reported_mileage}
                              // changeState={this.changeState}
                              error={odometerError}
                              onChange={this.handleChange}
                            />
                          </div>
                          <div className="additional_info">
                            <TextBox
                              heading="Additional Information"
                              onChange={this.handleChange}
                              name="notes"
                              placeholder="Please give specific and important details (for example: if there is a specific light on or error in the car)"
                            />
                            <p className="error-text">{detailsError}</p>
                          </div>
                          <div className="NewImageUploader">
                            <NewImageUploader
                              stateImages={this.state.images}
                              saveFileToState={this.saveFileToState}
                              removeImageFromState={
                                this.removeImageFromState
                              }
                              error={imageError}
                            />
                          </div>
                          <div>
                            We will process your report within 1-2 business
                            days.
                          </div>
                          <div
                            className=""
                            style={{ 'padding-bottom': '50px' }}
                          />
                          <button
                            id="submit-button"
                            style={{ display: 'none' }}
                            type="submit"
                          />
                        </NewValidatorForm>
                      </div>

                      {window.innerWidth >= 768 ? (
                        <DesktopFooter
                          onClick={() => {
                            this.handleFormSubmit();
                          }}
                        />
                      ) : null}
                    </div>
                  </div>
                  {/* </div> */}
                </EncourageScroll>
              </ScrollLock>
              <SendModal
                open={this.state.open}
                closeModal={this.closeModal}
                modalMessage={this.state.modalMessage}
              />
              <OfflineModal
                offline={this.state.offline}
                closeModal={this.closeModal}
              />
              <BookingPromptModal open={this.state.selectBookingPrompt} />
            </div>
          </Fragment>
        )}
      </Fragment>
    );
  };

  render() {
    const { loggedIn, status } = this.props;

    if (loggedIn && ['operating', 'weekly_lease'].includes(status)) {
      return this.report();
    }
    return <Redirect to="/dashboard" />;
  }
}

export default withRouter(Report);



// WEBPACK FOOTER //
// ./src/components/Report/index.js